module.exports = __webpack_public_path__ + "img/mobile-menu-history.8b6b27a7.webp";